import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleAlert, Loader2 } from '../../icons.js';
import { cn } from '../../lib/cn.js';
/**
 * The two states every screen in the product spends time in, said the same way
 * on all of them.
 *
 * They were said four ways before: `p-8 text-body text-text-secondary` on the
 * two layouts, `p-8` alone in the attempt runner, `text-body text-text-secondary`
 * on two more, and — on twenty-two of the thirty — a bare `<p role="status">`
 * with no class at all, which inherited whatever the parent happened to give
 * it. Every one of them was a screen saying "loading" or "that did not load",
 * and no two of them looked alike.
 *
 * ── Why the error is not just grey text ──────────────────────────────────
 *
 * `FieldMessage` states the rule this product already follows: an error always
 * carries the circular "!" glyph, because "colour never carries meaning
 * alone". Fifteen of these page-level errors were rendering as plain secondary
 * text — visually identical to the loading message directly above them in the
 * same file, so the only thing distinguishing "we are fetching this" from "we
 * could not fetch this" was the sentence itself.
 *
 * So `ErrorState` takes the same treatment its field-level sibling has had all
 * along: the glyph, and `text-error-text`. Not a new decision — the existing
 * one, applied where it had been missed.
 *
 * ── The roles ─────────────────────────────────────────────────────────────
 *
 * `role="status"` on loading and `role="alert"` on the error, which is what the
 * thirty sites already did and the one thing they agreed on. `alert` interrupts
 * because a screen that failed to load is a screen the reader is otherwise
 * about to be told nothing about.
 */
export function LoadingState({ children, className }) {
    return (_jsxs("p", { role: "status", className: cn('flex items-center gap-2.5 p-8 text-body text-text-secondary', className), children: [_jsx(Loader2, { "aria-hidden": "true", className: "size-icon-md shrink-0 animate-spin" }), _jsx("span", { children: children })] }));
}
export function ErrorState({ children, className }) {
    return (_jsxs("p", { role: "alert", className: cn('flex items-start gap-2.5 p-8 text-body font-medium text-error-text', className), children: [_jsx(CircleAlert, { "aria-hidden": "true", className: "mt-0.5 size-icon-md shrink-0" }), _jsx("span", { children: children })] }));
}
//# sourceMappingURL=StatusMessage.js.map